export default __webpack_public_path__ + "static/media/2.e9041035.png";